import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AlertHistoryComponent } from './alert-history.component';
import { AlertHistoryLogComponent } from './alert-history-log/alert-history-log.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { ViewAlertHistoryComponent } from './view-alert-history/view-alert-history.component';
import { AlertChatHistoryLogComponent } from './alert-chat-history-log/alert-chat-history-log.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: AlertHistoryComponent,
                canActivate: [AuthGuard]
            }, 
            {
                path: 'view-alert-history/:alertId',
                data: {
                    breadcrumb: 'view-alert'
                },
                component: ViewAlertHistoryComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'activity/:alertId',
                canActivate: [AuthGuard],
                children: [
                    {
                        path: '',
                        data: {
                            breadcrumb: 'activity'
                        },
                        component: AlertHistoryLogComponent,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'chat',
                            data: {
                                breadcrumb: 'chat'
                            },
                            component: AlertChatHistoryLogComponent,
                            canActivate: [AuthGuard]
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AlertHistoryRoutingModule { }
